export const initialDrawerData = {
    title: "",
    visibility: false,
    groupData: {},
  }